import React, { useState } from "react";
import { displayName } from "@/lib/names";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Link2, Loader2 } from "lucide-react";
import { PersonPicker } from "@/components/PersonPicker";

export const MergeDialog = ({ person, allPersons }) => {
  const { API } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState("");
  const [busy, setBusy] = useState(false);
  const options = (allPersons || []).filter(p => p.id !== person.id && !p.is_provisional);
  const chosen = options.find(p => p.id === target);

  const merge = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/persons/${person.id}/merge`, { target_id: target });
      toast.success("Fiche rattachée — les liens familiaux ont été reportés");
      setOpen(false);
      nav(`/persons/${target}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" className="border-[#A96B18] text-[#A96B18]" onClick={() => setOpen(true)} data-testid="open-merge-btn">
        <Link2 className="w-4 h-4 mr-2" /> Rattacher à une fiche existante
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#FAF7F2]">
          <DialogHeader>
            <DialogTitle className="font-serif-heritage text-2xl text-[#261911]">Rattacher « {displayName(person)} »</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-[#6E5B4F]">
            Choisissez la fiche complète qui correspond à cette personne. Ses liens (parents, enfants, conjoints) et ses sources y seront reportés.
            Les informations déjà présentes sur la fiche complète ne sont jamais écrasées. La fiche provisoire est conservée en archive.
          </p>
          <PersonPicker value={target} onChange={setTarget} options={options} testid="merge-target" placeholder="Rechercher la fiche existante" allowCreate={false} />
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="ghost" onClick={() => setOpen(false)}>Annuler</Button>
            <Button className="btn-terra" disabled={!chosen || busy} onClick={merge} data-testid="confirm-merge-btn">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Rattacher
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MergeDialog;
